module.exports = __webpack_public_path__ + "img/new_banner.4c05111e.jpg";